module.exports = __webpack_public_path__ + "media/images/signatures/sara_black-cb404381d37c8a185673a6a7ab8fcbb5.png";